import parse from 'html-react-parser';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import styled from 'styled-components';

import slideNext from 'assets/slideNext.svg';
import slidePrev from 'assets/slidePrev.svg';
import { colors } from 'styles/colors';
import { devices } from 'styles/devices';

const Slides = ({ posts }) => {
   const [slider, setSlider] = useState();
   const [current, setCurrent] = useState(1);

   const rendered = posts.map((p) => (
      <SlideContainer key={p.id} background={p.background}>
         <ReadMore to={`/news/${p.id}`}>
            <ReadMoreContainer>
               <Title>{parse(p.title)}</Title>
               <Content>{parse(p.content)}</Content>
            </ReadMoreContainer>
         </ReadMore>
      </SlideContainer>
   ));

   return (
      <Container>
         <Slider
            ref={(s) => setSlider(s)}
            initialSlide={1}
            arrows={false}
            afterChange={(e) => setCurrent(e === 0 ? 1 : e)}
         >
            {rendered}
         </Slider>
         {slider && (
            <ChaneSlideContainer>
               <ChangeSlideButton type="button" className="btn" onClick={slider.slickPrev}>
                  <img src={slidePrev} alt="" />
               </ChangeSlideButton>
               <ChaneSlideCurrent>
                  <span>{current}</span>
                  <span>/</span>
                  <span>{posts.length - 1}</span>
               </ChaneSlideCurrent>
               <ChangeSlideButton type="button" className="btn" onClick={slider.slickNext}>
                  <img src={slideNext} alt="" />
               </ChangeSlideButton>
            </ChaneSlideContainer>
         )}
      </Container>
   );
};

const Container = styled.div`
   position: relative;
   margin-bottom: 1.5rem;
   height: 320px;
   ${devices.mobileL} {
      margin-bottom: 3rem;
   }
   ${devices.tabletL} {
      margin-bottom: 6rem;
      height: 520px;
   }
`;

const SlideContainer = styled.div`
   height: 320px;
   ${(props) =>
      props.background
         ? `
      background-image: url("${props.background}");
   `
         : ''}
   ${devices.tabletL} {
      height: 520px;
   }
`;

const Title = styled.h2`
   color: #fff;
   font-size: 1.6rem;
   ${devices.tabletL} {
      font-size: 2.4rem;
      margin-bottom: 2rem;
   }
`;

const Content = styled.div`
   color: #fff;
   font-size: 0.8rem;
   word-break: break-word;
   line-height: 30px;
   max-height: 42%;
   overflow: hidden;
   ${devices.tabletL} {
      font-size: 1.2rem;
      max-height: 86%;
   }
`;

const ReadMore = styled(Link)`
   &,
   &:hover {
      text-decoration: none;
   }
`;

const ReadMoreContainer = styled.div`
   background: rgba(0, 0, 0, 0.8);
   height: 100%;
   width: 100%;
   padding: 1rem 1rem 0rem 1rem;
   ${devices.mobileL} {
      width: 520px;
   }
   ${devices.tabletL} {
      padding: 2rem 2rem 7rem 2rem;
   }
`;

const ChaneSlideContainer = styled.div`
   display: flex;
   align-items: center;
   margin-top: 2rem;
   position: absolute;
   left: 1rem;
   top: 226px;
   ${devices.mobile} {
      top: 228px;
   }
   ${devices.tabletL} {
      left: 2rem;
      top: 420px;
   }
`;

const ChaneSlideCurrent = styled.div`
   color: ${colors.white};
   margin: 0 1rem;
   span {
      margin: 0 0.25rem;
   }
`;

const ChangeSlideButton = styled.button`
   line-height: 1;
   padding: 0;
   font-size: 2.5rem;
   &:focus {
      box-shadow: none;
   }
   img {
      width: 40px;
      height: 40px;
   }
`;

export default Slides;
